'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CancellationReason = require('./CancellationReason.style');

var _CancellationReason2 = _interopRequireDefault(_CancellationReason);

var _DefaultElement = require('oy-vey/lib/components/DefaultElement.js');

var _DefaultElement2 = _interopRequireDefault(_DefaultElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Table = _DefaultElement2.default.Table,
    TBody = _DefaultElement2.default.TBody,
    TR = _DefaultElement2.default.TR,
    TD = _DefaultElement2.default.TD;


function CancellationReason(_ref) {
    var reason = _ref.reason,
        i18n = _ref.i18n,
        fontFamily = _ref.fontFamily,
        paddingVertical = _ref.paddingVertical,
        paddingHorizontal = _ref.paddingHorizontal,
        marginTop = _ref.marginTop;

    var styles = (0, _CancellationReason2.default)({
        rtl: i18n.getDir() === 'rtl',
        fontFamily: fontFamily,
        paddingVertical: paddingVertical,
        paddingHorizontal: paddingHorizontal,
        marginTop: marginTop
    });

    return _react2.default.createElement(
        Table,
        { width: '100%' },
        _react2.default.createElement(
            TBody,
            null,
            _react2.default.createElement(
                TR,
                null,
                _react2.default.createElement(
                    TD,
                    null,
                    _react2.default.createElement(
                        'div',
                        { style: styles.cancellationReason },
                        _react2.default.createElement(
                            'div',
                            { style: styles.cancellationReasonInner },
                            _react2.default.createElement(
                                'div',
                                { style: styles.cancellationReasonTitle },
                                i18n.get('modify_reservation_reason_for_cancellation', 'reason for cancellation')
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                reason
                            )
                        )
                    )
                )
            )
        )
    );
}

CancellationReason.displayName = 'CancellationReason';

CancellationReason.propTypes = {
    i18n: _propTypes2.default.object,
    reason: _propTypes2.default.string,
    fontFamily: _propTypes2.default.string,
    paddingVertical: _propTypes2.default.number,
    paddingHorizontal: _propTypes2.default.number,
    marginTop: _propTypes2.default.number
};

exports.default = CancellationReason;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wix-restaurants-renderer-js/dist/CancellationReason.js
// module id = 1152
// module chunks = 0